import React, { useContext, useLayoutEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { AuthCookieContext } from 'utils/context';
import { getRenderer } from './renderers';
import { Transition } from 'react-transition-group';
import { Box, CircularProgress } from '@mui/material';
import PageWrapper from './PageWrapper';
import SuspendDynamicProps from './SuspendDynamicProps';

const duration = 150;

const defaultStyle = {
  width: '100%',
  height: '100%',
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: 1,
};

const transitionStyles = {
  entering: { opacity: 0 },
  entered: { opacity: 1 },
  exiting: { opacity: 0 },
  exited: { opacity: 0 },
};

const loaderTransitionStyles = {
  entering: { opacity: 0 },
  entered: { display: 'none', opacity: 0 },
  exiting: { opacity: 0 },
  exited: { opacity: 1 },
};

const DynamicPage = () => {
  const { pageName } = useParams();

  const [isLoading, setIsLoading] = useState(false);

  const { templateConfig } = useContext(AuthCookieContext);

  const quizConfig = templateConfig?.quizConfig;
  const pageConfig = quizConfig?.[pageName];
  const Renderer = getRenderer(pageConfig?.renderer);

  // const prefetchedNextRef = useRef(null);

  // useEffect(() => {
  //   if (!pageName || !quizConfig) return;
  //   if (isLoading || isTransitioning) return;

  //   const nextPage = quizConfig?.[pageName]?.nextPage;
  //   if (!nextPage) return;

  //   if (prefetchedNextRef.current === nextPage) return;
  //   prefetchedNextRef.current = nextPage;

  //   const nextCfg = quizConfig?.[nextPage];

  //   if (nextCfg?.renderer === 'static') {
  //     import(
  //       /* webpackPrefetch: true */ `./renderers/static/pages/${nextPage}`
  //     ).catch(() => {});
  //   }
  // }, [pageName, quizConfig, isLoading, isTransitioning]);

  useLayoutEffect(() => {
    setIsLoading(true);
  }, [pageName]);

  if (!pageName) {
    return <Navigate to={`./${quizConfig.startPage}`} />;
  }

  if (!Renderer) return null;

  const showingContent = !isLoading;
  return (
    <PageWrapper pageName={pageName}>
      <Transition timeout={duration} in={showingContent}>
        {(state) => {
          console.log(state);
          return (
            <>
              <CircularProgress
                style={{
                  position: 'fixed',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  zIndex: 1000,
                  transition: `opacity ${duration}ms ease-in-out`,
                  ...loaderTransitionStyles[state],
                }}
              />
              <Box
                style={{
                  ...defaultStyle,
                  ...transitionStyles[state],
                }}
              >
                <SuspendDynamicProps
                  Component={Renderer}
                  pageName={pageName}
                  quizConfig={quizConfig}
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                  delay={duration}
                />
              </Box>
            </>
          );
        }}
      </Transition>
    </PageWrapper>
  );
};

export default DynamicPage;
